/*
 * @Description: 主题色、大标题、小标题、页码、水印
 * @Date: 2024-01-15 14:09:19
 */
import BiTmplDetail_101 from './bi-tmpl-detail-101.vue';
export default BiTmplDetail_101;
